import { Typography } from 'antd';
import { ReactNode } from 'react';

const { Text } = Typography;

interface TitleWithInfoProps {
  title: ReactNode;
  description: ReactNode;
  blockClassName?: string;
  titleClassName?: string;
}

export const TitleWithInfo = ({
  title,
  description,
  titleClassName = '',
  blockClassName = '',
}: TitleWithInfoProps) => {
  if (!title) {
    return null;
  }

  return (
    <div className={`flex flex-col ${blockClassName}`}>
      <h1 className={`${titleClassName}`}>{title}</h1>
      {description && (
        <Text type="secondary" className="text-sm mt-1 block">
          {description}
        </Text>
      )}
    </div>
  );
};
